let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fHoIY")).then(() => parcelRequire('8xVOG'));